import VimeoPlayer from './VimeoPlayer';
import YoutubePlayer from './YoutubePlayer';

export {
    VimeoPlayer,
    YoutubePlayer,
};
